import { Box, Typography } from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import logoUrl from "@/assets/logos/talk2buy-logo-report.png";

type Props = { layout: "A" | "R" };

const muted = "#7b809a";
const dark = "#344767";
const font = "Roboto, Helvetica, Arial, sans-serif";

const Divider = () => (
  <Box sx={{ height: "1px", my: 2, mx: "auto", width: "70%", background: "linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.12), rgba(0,0,0,0))" }} />
);

function A4Preview() {
  const row = (l: string, v: string) => (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Box sx={{ fontSize: 11, color: muted }}>{l}</Box>
      <Box sx={{ fontSize: 13, fontWeight: 700, color: dark }}>{v}</Box>
    </Box>
  );
  const info = (l: string, v: string) => (
    <Box sx={{ fontSize: 10, color: muted, mb: 0.6 }}>
      {l}: <Box component="span" sx={{ color: dark, fontWeight: 700, ml: 0.5 }}>{v}</Box>
    </Box>
  );
  const title = (t: string) => <Box sx={{ fontWeight: 600, fontSize: 13, color: dark, mb: 1.5 }}>{t}</Box>;
  return (
    <Box sx={{ bgcolor: "#fff", color: dark, width: 592, minWidth: 592, p: "20px 12px", border: "1px solid #ddd", mx: "auto", fontFamily: font }}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Box sx={{ fontSize: 10, color: muted }}>Pedido: 2-1790265963982 de 9/24/2026 1:06:04 PM</Box>
          <Box sx={{ fontSize: 10, color: muted }}>Canal: <b style={{ color: muted }}>Talk2Buy</b></Box>
        </Box>
        <Box component="img" src={logoUrl} alt="Talk2Buy" sx={{ height: 56, width: "auto" }} />
      </Box>
      <Divider />
      {title("Informações de Envio")}
      <Box sx={{ bgcolor: "#f8f9fa", borderRadius: 2, p: "20px 18px" }}>
        <Box sx={{ fontWeight: 700, fontSize: 10, mb: 2 }}>Cliente Teste</Box>
        {info("CPF/CNPJ ", "000.000.000-00 (Teste)")}
        {info("Celular", "55 (11) 90000-0000 (Teste)")}
        {info("Endereço", "Rua Teste, 123, Bairro Teste, Cidade Teste, SP, BRASIL, CEP: 01001000")}
      </Box>
      <Divider />
      <Box sx={{ borderRadius: 2, boxShadow: "0 2px 6px rgba(0,0,0,0.12)", overflow: "hidden" }}>
        <Box component="table" sx={{ width: "100%", borderCollapse: "collapse", fontSize: 9, color: dark, "& th": { bgcolor: "#f0f2f5", fontWeight: 700, p: "14px 10px" }, "& td": { p: "16px 10px" } }}>
          <thead><tr>
            <th style={{ textAlign: "left" }}>SKU</th><th style={{ textAlign: "left" }}>PRODUTO</th>
            <th style={{ textAlign: "right" }}>QTDE</th><th style={{ textAlign: "right" }}>PREÇO</th><th style={{ textAlign: "right" }}>TOTAL</th>
          </tr></thead>
          <tbody><tr>
            <td>T2B0000030</td><td>Caneca acrílica - Cor: Branco</td>
            <td style={{ textAlign: "right" }}>1</td><td style={{ textAlign: "right" }}>R$ 60,00</td><td style={{ textAlign: "right" }}>R$ 60,00</td>
          </tr></tbody>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" gap={8}>
        <Box sx={{ width: 274 }}>
          {title("Pagamentos")}
          <Box sx={{ border: "1px solid #b8bccb", borderRadius: 1, p: "18px 18px", display: "flex", gap: 1.5, alignItems: "center" }}>
            <MonetizationOnIcon sx={{ color: "#16D3D9", fontSize: 26 }} />
            <Box>
              <Box sx={{ fontSize: 12, color: dark }}>Cartão</Box>
              <Box sx={{ fontSize: 13, color: muted }}>R$ 71,99</Box>
            </Box>
          </Box>
          <Box mt={2.5}>{title("Observações")}</Box>
          <Box sx={{ border: "1px solid #b8bccb", borderRadius: 1, p: "30px 18px", fontSize: 12, fontWeight: 600 }}>Data prevista de entrega: 22/10/2026</Box>
          <Box sx={{ fontSize: 12, color: muted, mt: 2 }}>Pedido gerado por <b style={{ color: "#000" }}>Talk2Buy</b></Box>
        </Box>
        <Box flex={1}>
          {title("Resumo do Pedido")}
          {row("Produtos", "R$ 60,00")}
          {row("Descontos", "R$ 0,00")}
          {row("Frete", "(Sedex) R$ 11,99")}
          {row("Encargos", "R$ 0,00")}
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
            <Box sx={{ fontSize: 14, color: muted }}>Total</Box>
            <Box sx={{ fontSize: 15, fontWeight: 700 }}>R$ 71,99</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function ReceiptPreview() {
  const sep = <Box sx={{ borderTop: "2px dashed #222", my: "5px" }} />;
  const lr = (l: string, r: string, bold = false) => (
    <Box display="flex" justifyContent="space-between" fontWeight={bold ? 700 : 400}><span>{l}</span><span>{r}</span></Box>
  );
  const h = (t: string) => <Box fontWeight={700}>{t}</Box>;
  return (
    <Box sx={{ bgcolor: "#fdf7dc", color: "#222", width: 416, minWidth: 416, p: "8px 20px", border: "1px solid #e6dfb8", fontFamily: "'Courier New', Courier, monospace", fontSize: 12, lineHeight: 1.6, mx: "auto", whiteSpace: "pre" }}>
      <Box textAlign="center" fontWeight={700}>*** TALK2BUY ***</Box>
      <Box textAlign="center" fontWeight={700}>COMPROVANTE DE PEDIDO</Box>
      <Box textAlign="center">DOCUMENTO SEM VALOR FISCAL</Box>
      {sep}
      <Box>Pedido: 2-1790199270860</Box>
      <Box>Data: 23/09/2026 18:34:31</Box>
      <Box>Canal: Talk2Buy</Box>
      {sep}
      {h("CLIENTE / ENTREGA")}
      <Box>Cliente Teste</Box>
      <Box>CPF/CNPJ: 000.000.000-00 (Teste)</Box>
      <Box>Celular: 55 (11) 90000-0000 (Teste)</Box>
      <Box>Endereço:</Box>
      <Box>Rua Teste, 123</Box>
      <Box>Bairro Teste</Box>
      <Box>Cidade Teste - SP</Box>
      <Box>BRASIL</Box>
      <Box>CEP: 01001-000</Box>
      {sep}
      {h("ITENS DO PEDIDO")}
      <Box>QTD SKU PRODUTO</Box>
      <Box>1 T2B0000029 Caneca acrílica - Cor: Prata</Box>
      {lr("Unit. R$ 60,00", "Total R$ 60,00")}
      {sep}
      {h("RESUMO DO PEDIDO")}
      {lr("Produtos:", "R$ 60,00")}
      {lr("Descontos:", "R$ 0,00")}
      {lr("Frete (Retirada na loja):", "R$ 0,00")}
      {lr("Encargos:", "R$ 0,00")}
      {lr("TOTAL:", "R$ 60,00", true)}
      {sep}
      {h("PAGAMENTOS")}
      {lr("Cartão", "R$ 60,00")}
      {sep}
      {h("OBSERVAÇÕES")}
      <Box>Data prevista de entrega: 07/10/2026</Box>
      {sep}
      <Box textAlign="center">Pedido gerado por Talk2Buy</Box>
      <Box textAlign="center">DOCUMENTO SEM VALOR FISCAL</Box>
    </Box>
  );
}

export default function OrderReportLayoutPreview({ layout }: Props) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block" mb={1}>
        Pré-visualização (dados de exemplo)
      </Typography>
      <Box
        sx={{
          overflowX: "auto",
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "#f0f2f5",
          backgroundImage: [
            "radial-gradient(circle at 12% 18%, rgba(102,119,129,0.07) 0%, transparent 42%)",
            "radial-gradient(circle at 88% 12%, rgba(102,119,129,0.06) 0%, transparent 38%)",
            "radial-gradient(circle at 70% 82%, rgba(102,119,129,0.05) 0%, transparent 40%)",
            "radial-gradient(circle at 25% 75%, rgba(102,119,129,0.06) 0%, transparent 35%)",
          ].join(", "),
          p: 2,
        }}
      >
        <Box sx={{ boxShadow: "0 2px 10px rgba(0,0,0,0.12)", width: "fit-content", mx: "auto" }}>
          {layout === "R" ? <ReceiptPreview /> : <A4Preview />}
        </Box>
      </Box>
    </Box>
  );
}
